<template>
  <div class="dashboard-sections dashboard-sections--servicos">
    <section class="ws-dash-serv-section">
      <header class="ws-dash-serv-section__header">
        <div class="ws-dash-serv-section__title-wrap">
          <span class="ws-dash-serv-section__icon" aria-hidden="true">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
            </svg>
          </span>
          <div>
            <h2 class="ws-dash-serv-section__title">{{ t('workspaceDashboard.servicos.sections.proximosAgendamentos') }}</h2>
            <p class="ws-dash-serv-section__sub">{{ t('workspaceDashboard.servicos.sections.proximosAgendamentosSub') }}</p>
          </div>
        </div>
        <RouterLink :to="agendaLink" class="ws-dash-serv-section__cta">
          {{ t('workspaceDashboard.servicos.verAgenda') }}
        </RouterLink>
      </header>

      <div class="ws-dash-serv-agenda__group">
        <h3 class="ws-dash-serv-agenda__group-title">{{ t('workspaceDashboard.servicos.hoje') }}</h3>
        <div v-if="loading" class="ws-dash-serv-agenda__empty">{{ t('workspaceDashboard.servicos.loading') }}</div>
        <div v-else-if="!agenda.itensHoje?.length" class="ws-dash-serv-agenda__empty">
          {{ t('workspaceDashboard.servicos.sections.emptyHoje') }}
        </div>
        <div v-else class="ws-dash-serv-agenda__list">
          <article v-for="item in agenda.itensHoje" :key="item.id" class="ws-dash-serv-agenda__item">
            <span class="ws-dash-serv-agenda__time">{{ item.horario || '—' }}</span>
            <span class="ws-dash-serv-agenda__name">{{ item.clienteNome || '—' }}</span>
            <span v-if="item.motivo" class="ws-dash-serv-agenda__motivo">{{ item.motivo }}</span>
          </article>
        </div>
      </div>

      <div class="ws-dash-serv-agenda__group">
        <h3 class="ws-dash-serv-agenda__group-title">{{ t('workspaceDashboard.servicos.amanha') }}</h3>
        <div v-if="loading" class="ws-dash-serv-agenda__empty">{{ t('workspaceDashboard.servicos.loading') }}</div>
        <div v-else-if="!agenda.itensAmanha?.length" class="ws-dash-serv-agenda__empty">
          {{ t('workspaceDashboard.servicos.sections.emptyAmanha') }}
        </div>
        <div v-else class="ws-dash-serv-agenda__list">
          <article v-for="item in agenda.itensAmanha" :key="item.id" class="ws-dash-serv-agenda__item">
            <span class="ws-dash-serv-agenda__time">{{ item.horario || '—' }}</span>
            <span class="ws-dash-serv-agenda__name">{{ item.clienteNome || '—' }}</span>
            <span v-if="item.motivo" class="ws-dash-serv-agenda__motivo">{{ item.motivo }}</span>
          </article>
        </div>
      </div>
    </section>

    <section class="ws-dash-serv-section">
      <header class="ws-dash-serv-section__header">
        <div class="ws-dash-serv-section__title-wrap">
          <span class="ws-dash-serv-section__icon ws-dash-serv-section__icon--finance" aria-hidden="true">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"/>
            </svg>
          </span>
          <div>
            <h2 class="ws-dash-serv-section__title">{{ t('workspaceDashboard.servicos.sections.financeiroMes') }}</h2>
            <p class="ws-dash-serv-section__sub">{{ t('workspaceDashboard.servicos.sections.financeiroMesSub') }}</p>
          </div>
        </div>
        <RouterLink :to="financeiroLink" class="ws-dash-serv-section__cta">
          {{ t('workspaceDashboard.servicos.abrirFinanceiro') }}
        </RouterLink>
      </header>

      <div class="ws-dash-serv-section__finance">
        <WorkspaceFinanceiroServicosForecast v-if="!loading" :forecast="forecast" />
        <div v-else class="ws-dash-serv-agenda__empty">{{ t('workspaceDashboard.servicos.loading') }}</div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import WorkspaceFinanceiroServicosForecast from '@/components/workspace-financeiro/WorkspaceFinanceiroServicosForecast.vue'

const props = defineProps({
  workspaceId: { type: [String, Number], required: true },
  loading: { type: Boolean, default: false },
  agenda: {
    type: Object,
    default: () => ({ itensHoje: [], itensAmanha: [] })
  },
  forecast: { type: Object, required: true }
})

const { t } = useI18n()

const agendaLink = computed(() => `/workspace/${props.workspaceId}/agenda`)
const financeiroLink = computed(() => `/workspace/${props.workspaceId}/financeiro`)
</script>

<style src="@/assets/styles/workspace-dashboard-servicos.css"></style>
<style src="@/assets/styles/workspace-financeiro-servicos.css"></style>
